/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the 'product:added' event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * 'cart:refresh' in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const openModals = [];

const showModal = (modalName) => {
  openModals.push(modalName);

  const modal = document.querySelector(`[data-modal='${modalName}']`);
  document.body.classList.add("body-hidden");
  modal.setAttribute("aria-hidden", "false");
};

const hideModal = (modalName) => {
  openModals.splice(openModals.indexOf(modalName), 1);

  const modal = document.querySelector(`[data-modal='${modalName}']`);
  if (!openModals.length) document.body.classList.remove("body-hidden");
  modal.setAttribute("aria-hidden", "true");
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

const setCookie = (name, value, date) => {
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

window.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (event) => {
    const target = event.target.closest("[data-toggle-modal]");

    if (target) {
      const modalName = target.getAttribute("data-toggle-modal");
      showModal(modalName);
      window.dispatchEvent(
        new CustomEvent("modalOpened", { detail: modalName })
      );
    }
  });

  document.querySelectorAll("[data-modal] .modal__close").forEach((element) => {
    const modalName = element
      .closest("[data-modal]")
      .getAttribute("data-modal");

    element.addEventListener("click", () => {
      hideModal(modalName);
      window.dispatchEvent(
        new CustomEvent("modalClosed", { detail: modalName })
      );
    });
  });
});

window.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("sticky-header");
  const announcementBar = document.getElementById(
    "shopify-section-announcement-bar"
  );

  const calculateVisibleHeader = () => {
    const getVisibleHeight = (element) => {
      if(!element) return 0;
      const { top, bottom, height } = element.getBoundingClientRect();
      return Math.max(
        0,
        Math.min(bottom, window.innerHeight) - Math.max(0, top)
      );
    };
    
    document.body.style.setProperty(
      "--visible-header",
      `${Math.floor(getVisibleHeight(header) + getVisibleHeight(announcementBar))}px`
    );
  };

  calculateVisibleHeader();
  window.addEventListener("scroll", calculateVisibleHeader);
  new ResizeObserver(calculateVisibleHeader).observe(header);
});

const injectStyleOnMutate = ({
  targetContainer = document.body,
  elementTagName,
  cssStyles,
  onElementAdded = null,
  onElementRemoved = null,
}) => {
  const applyStyles = (element, styles) => {
    if (element.shadowRoot) {
      const styleElement = document.createElement("style");
      styleElement.textContent = styles;
      element.shadowRoot.appendChild(styleElement);
    } else {
      element.addEventListener("DOMContentLoaded", () => applyStyles(element, styles), {
        once: true,
      });
    }
  };

  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(({ addedNodes, removedNodes }) => {
      addedNodes.forEach(node => {
        if (
          node instanceof HTMLElement &&
          node.tagName.toLowerCase() === elementTagName.toLowerCase()
        ) {
          applyStyles(node, cssStyles);
          if (onElementAdded) onElementAdded(node);
        }
      });

      if (onElementRemoved) {
        removedNodes.forEach(node => {
          if (
            node instanceof HTMLElement &&
            node.tagName.toLowerCase() === elementTagName.toLowerCase()
          ) {
            onElementRemoved(node);
          }
        });
      }
    });
  });

  mutationObserver.observe(targetContainer, {
    childList: true,
    subtree: true,
  });

  targetContainer
    .querySelectorAll(elementTagName)
    .forEach(existingElement => {
      applyStyles(existingElement, cssStyles);
      if (onElementAdded) onElementAdded(existingElement);
    });

  return mutationObserver;
};

window.addEventListener("sparkLayerReady", () => {
  const isTrolley = window.sparkCustomer.isTrolley;
  let cssStyles = `
    .grow > :not([class]) > .flex.flex-wrap.items-center:not(.text-error) {
      display: none !important;
    }
  `;

  if(isTrolley) {
    cssStyles = cssStyles + `
      .fixed.start-0.top-0.z-99999.bg-drawer-overlay-bg {
        z-index: 3;
      }

      .fixed.inset-y-0.z-99999.mx-auto.my-0.flex {
        z-index: 5;
      }

      @media (max-width: 989px) {
        .fixed.inset-y-0.z-99999.mx-auto.my-0.flex {
          top: var(--visible-header);
          min-height: calc(100dvh - var(--visible-header));
          height: calc(100dvh - var(--visible-header));
        }
      }
    `;
  }

  const headerElement = document.querySelector('sticky-header');

  injectStyleOnMutate({
    targetContainer: document.body,
    elementTagName: 'spark-drawer',
    cssStyles,
    onElementAdded: () => isTrolley && headerElement?.classList.add('spark-cart--open'),
    onElementRemoved: () => isTrolley && headerElement?.classList.remove('spark-cart--open'),
  });
});

const overwriteSparkStyles = () => {
  const cssStyles = `
    .flex.flex-wrap.items-center.text-info svg-history,
    .flex.flex-wrap.items-center.text-info svg-history ~ * { 
      display: none !important; 
    }
  `;

  const sparkCards = document.querySelectorAll("spark-product-card, spark-pdp");
  sparkCards.forEach((element) => {
    const styleElement = document.createElement("style");
    styleElement.textContent = cssStyles;
    element.shadowRoot.prepend(styleElement);
  });
}
window.overwriteSparkStyles = overwriteSparkStyles;

window.addEventListener("sparkLayerReady", () => {
  const purchaseButtonObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          const button = node.querySelector(".button-purchase button");
          if (!button) return;

          button.addEventListener("click", (event) => {
            if (!sessionStorage.getItem("sparkLayerUpsellsShown")) {
              showModal("sparklayer-upsells");
              sessionStorage.setItem("sparkLayerUpsellsShown", true);
            }
          });
          purchaseButtonObserver.disconnect();
        }
      });
    });
  });

  overwriteSparkStyles();
});